module.exports = __webpack_public_path__ + "img/io.83d45bbb.png";